import styled from "styled-components";
import { buttonHeights, getButtonPadding } from "../utils";
export const StyledButton = styled.button `
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${({ theme }) => theme.fontTokens.defaultFont};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  ${({ rounded }) => (rounded ? "border-radius: 50%" : "")};
  background-color: ${({ stylingType }) => stylingType.background};
  color: ${({ stylingType }) => stylingType.color};
  border: 1px solid ${({ stylingType }) => stylingType.border};
  box-sizing: border-box;
  white-space: nowrap;
  span {
    display: flex;
    justify-content: center;
    align-content: center;
  }
  svg {
    fill: ${({ stylingType }) => stylingType.color};
  }

  @media (hover: hover) {
    &:hover {
      ${({ stylingType, selected }) => {
    var _a;
    return !selected && ((_a = stylingType.hover) === null || _a === void 0 ? void 0 : _a.color)
        ? `color: ${stylingType.hover.color};`
        : "";
}};
      ${({ stylingType, selected }) => {
    var _a;
    return !selected && ((_a = stylingType.hover) === null || _a === void 0 ? void 0 : _a.background)
        ? `background-color: ${stylingType.hover.background};`
        : "";
}};
      ${({ stylingType, selected }) => {
    var _a;
    return !selected && ((_a = stylingType.hover) === null || _a === void 0 ? void 0 : _a.border)
        ? `border: 1px solid ${stylingType.hover.border};`
        : "";
}};

      svg {
        ${({ stylingType, selected }) => {
    var _a;
    return !selected && ((_a = stylingType.hover) === null || _a === void 0 ? void 0 : _a.color)
        ? `fill: ${stylingType.hover.color};`
        : "";
}};
      }
    }
  }

  &:focus {
    ${({ stylingType, focused }) => {
    var _a;
    return ((_a = stylingType.focus) === null || _a === void 0 ? void 0 : _a.border) && focused
        ? `border: 1px solid ${stylingType.focus.border};`
        : "";
}};
    ${({ stylingType, focused, rounded }) => {
    var _a;
    return ((_a = stylingType.focus) === null || _a === void 0 ? void 0 : _a.border) && focused
        ? !rounded
            ? `outline: 1px solid ${stylingType.focus.border};`
            : `outline: none; box-shadow: 0 0 0 1px ${stylingType.focus.border}; border-radius: 50%;`
        : "outline: none;";
}};
  }

  ::-moz-focus-inner {
    border: 0;
  }

  ${({ stylingType, selected }) => {
    var _a;
    return selected && ((_a = stylingType.active) === null || _a === void 0 ? void 0 : _a.color)
        ? `color: ${stylingType.active.color}`
        : "";
}};
  ${({ stylingType, selected }) => {
    var _a;
    return selected && ((_a = stylingType.active) === null || _a === void 0 ? void 0 : _a.background)
        ? `background-color: ${stylingType.active.background};`
        : "";
}};
  ${({ stylingType, selected }) => {
    var _a;
    return selected && ((_a = stylingType.active) === null || _a === void 0 ? void 0 : _a.border)
        ? `border: 1px solid ${stylingType.active.border};`
        : "";
}};

  svg {
    fill: ${({ theme, stylingType, selected }) => selected
    ? stylingType.type !== "flatInverted"
        ? theme.colors.white
        : stylingType.active.color
    : ""};
  }

  &:active {
    ${({ theme }) => theme.global.disableTapHighlight}

    ${({ stylingType, active }) => {
    var _a;
    return ((_a = stylingType.active) === null || _a === void 0 ? void 0 : _a.color) && active
        ? `color: ${stylingType.active.color}`
        : "";
}};
    ${({ stylingType, active }) => {
    var _a;
    return ((_a = stylingType.active) === null || _a === void 0 ? void 0 : _a.background) && active
        ? `background-color: ${stylingType.active.background};`
        : "";
}};
    ${({ stylingType, active }) => {
    var _a;
    return ((_a = stylingType.active) === null || _a === void 0 ? void 0 : _a.border) && active
        ? `border: 1px solid ${stylingType.active.border};`
        : "";
}};

    svg {
      ${({ stylingType, active }) => {
    var _a;
    return ((_a = stylingType.active) === null || _a === void 0 ? void 0 : _a.color) && active
        ? `fill: ${stylingType.active.color}`
        : "";
}};
    }
  }

  &:disabled {
    cursor: default;
    ${({ stylingType }) => {
    var _a;
    return ((_a = stylingType.disabled) === null || _a === void 0 ? void 0 : _a.color)
        ? `color: ${stylingType.disabled.color}`
        : "";
}};
    ${({ stylingType }) => {
    var _a;
    return ((_a = stylingType.disabled) === null || _a === void 0 ? void 0 : _a.background)
        ? `background-color: ${stylingType.disabled.background};`
        : "background-color: transparent";
}};
    border: ${({ stylingType }) => {
    var _a;
    return `1px solid ${((_a = stylingType.disabled) === null || _a === void 0 ? void 0 : _a.border)
        ? stylingType.disabled.border
        : stylingType.border};`;
}};

    svg {
      ${({ stylingType }) => {
    var _a;
    return ((_a = stylingType.disabled) === null || _a === void 0 ? void 0 : _a.color)
        ? `fill: ${stylingType.disabled.color};`
        : "";
}};
    }
  }

  ${({ isIcon, stretched, itemHeight, isVideo, stylingType }) => {
    if (isVideo)
        return "";
    if (isIcon) {
        return `width: ${itemHeight.xsmall}rem;`;
    }
    if (stretched.xsmall) {
        return "min-width: 100%;";
    }
    if (stylingType.type && stylingType.type.includes("flat")) {
        return `min-width: 2.5rem;`;
    }
    return `min-width: 6.25rem;`;
}}

  ${({ itemHeight, theme }) => itemHeight.xsmall >= buttonHeights.large
    ? `
        font-size: ${theme.fontTokens.font11[0]}; 
        line-height: ${theme.fontTokens.font11[1]};
        svg {
          width: 1.25rem;
        }
        `
    : `
      font-size: ${theme.fontTokens.font12[0]}; 
      line-height: ${theme.fontTokens.font12[1]};
      svg {
        width: 1rem;
      }
      `};

  ${({ isVideo, itemHeight }) => !isVideo ? `height: ${itemHeight.xsmall}rem` : ""};

  span {
    ${({ isVideo, itemHeight }) => !isVideo ? `height: ${itemHeight.xsmall}rem` : ""};
    ${({ itemHeight }) => `min-width: ${itemHeight.xsmall}rem;`}
    ${({ hasChildren, symbol, itemHeight }) => hasChildren && symbol
    ? `
          width: ${itemHeight.xsmall}rem;
          display: flex; justify-content: center;
        `
    : ""};
  }

  ${({ isIcon, hasChildren, symbol, iconAlignment, isVideo, itemHeight, stylingType, alignByContent, }) => {
    if (isVideo || isIcon)
        return "padding: 0;";
    if (hasChildren && symbol) {
        return `
      padding: 0 ${iconAlignment === "left" ? "1rem" : 0} 0 ${iconAlignment === "right" ? "1rem" : 0};
      ${alignByContent === "left"
            ? "transform: translate(-1rem);"
            : alignByContent === "right"
                ? "transform: translate(1rem);"
                : ""}
      `;
    }
    return `
    padding: ${getButtonPadding(itemHeight.xsmall)} ${["primary", "secondary"].indexOf(stylingType.type) >= 0
        ? "1.5rem"
        : "1rem"};
    ${alignByContent === "left"
        ? `transform: translate(${["primary", "secondary"].indexOf(stylingType.type) >= 0
            ? "-1.5rem"
            : "-1rem"});`
        : alignByContent === "right"
            ? `transform: translate(${["primary", "secondary"].indexOf(stylingType.type) >= 0
                ? "1.5rem"
                : "1rem"});`
            : ""}
    `;
}};

  ${({ isIcon, isVideo, itemHeight, alignByContent }) => isVideo || isIcon
    ? alignByContent === "left"
        ? `transform: translate(-${((itemHeight.xsmall || 2) -
            (itemHeight.xsmall || buttonHeights.large <= 2 ? 1.25 : 1)) /
            2}rem);`
        : alignByContent === "right"
            ? `transform: translate(${((itemHeight.xsmall || 2) -
                (itemHeight.xsmall || buttonHeights.large <= 2 ? 1.25 : 1)) /
                2}rem);`
            : ""
    : ""};

  @media ${({ theme }) => theme.device.small} {
    ${({ isVideo, itemHeight }) => !isVideo && itemHeight.small ? `height: ${itemHeight.small}rem` : ""};
    span {
      ${({ isVideo, itemHeight }) => !isVideo ? `height: ${itemHeight.xsmall}rem` : ""};
      ${({ itemHeight }) => `min-width: ${itemHeight.xsmall}rem;`}
    }
    ${({ itemHeight, theme }) => {
    if (!itemHeight.small)
        return "";
    if (itemHeight.small >= buttonHeights.large)
        return `
        font-size: ${theme.fontTokens.font11[0]}; 
        line-height: ${theme.fontTokens.font11[1]};
        svg {
          width: 1.25rem;
        }
        `;
    return `
      font-size: ${theme.fontTokens.font12[0]}; 
      line-height: ${theme.fontTokens.font12[1]};
      svg {
        width: 1rem;
      }
      `;
}}

    ${({ isIcon, stretched, itemHeight, isVideo, stylingType, symbol }) => {
    if (isVideo)
        return "";
    if (isIcon) {
        return itemHeight.small ? `width: ${itemHeight.small}rem;` : "";
    }
    if (stretched.small) {
        return "min-width: 100%;";
    }
    if (stylingType.type && stylingType.type.includes("flat")) {
        if (symbol) {
            return `min-width: 3.75rem;`;
        }
        return `min-width: 2.5rem;`;
    }
    return `min-width: 6.25rem;`;
}}

    ${({ isIcon, isVideo, itemHeight, alignByContent }) => isVideo || isIcon
    ? alignByContent === "left"
        ? `transform: translate(-${((itemHeight.small || itemHeight.xsmall) -
            (itemHeight.small || itemHeight.xsmall >= buttonHeights.large
                ? 1.25
                : 1)) /
            2}rem);`
        : alignByContent === "right"
            ? `transform: translate(${((itemHeight.small || itemHeight.xsmall) -
                (itemHeight.small || itemHeight.xsmall >= buttonHeights.large
                    ? 1.25
                    : 1)) /
                2}rem);`
            : ""
    : ""};
  }

  @media ${({ theme }) => theme.device.medium} {
    ${({ isVideo, itemHeight }) => !isVideo && itemHeight.medium ? `height: ${itemHeight.medium}rem` : ""};
    span {
      ${({ isVideo, itemHeight }) => !isVideo ? `height: ${itemHeight.medium}rem` : ""};
      ${({ itemHeight }) => `min-width: ${itemHeight.medium}rem;`}
    }
    ${({ itemHeight, theme }) => {
    if (!itemHeight.medium)
        return "";
    if (itemHeight.medium >= buttonHeights.large)
        return `font-size: ${theme.fontTokens.font11[0]}; line-height: ${theme.fontTokens.font11[1]};`;
    return `font-size: ${theme.fontTokens.font12[0]}; line-height: ${theme.fontTokens.font12[1]};`;
}}
    ${({ isIcon, stretched, itemHeight, isVideo, stylingType, symbol }) => {
    if (isVideo)
        return "";
    if (isIcon) {
        return itemHeight.medium ? `width: ${itemHeight.medium}rem;` : "";
    }
    if (stretched.medium) {
        return "min-width: 100%;";
    }
    if (stylingType.type && stylingType.type.includes("flat")) {
        if (symbol) {
            return `min-width: 3.75rem;`;
        }
        return `min-width: 2.5rem;`;
    }
    return `min-width: 6.25rem;`;
}}

    ${({ isIcon, hasChildren, symbol, isVideo, itemHeight, stylingType, alignByContent, }) => !isVideo && !isIcon && (!symbol || !hasChildren)
    ? `
        padding: ${getButtonPadding(itemHeight === null || itemHeight === void 0 ? void 0 : itemHeight.medium)} ${["primary", "secondary"].indexOf(stylingType.type) >= 0
        ? "1.5rem"
        : "1rem"};
          ${alignByContent === "left"
        ? `transform: translate(${["primary", "secondary"].indexOf(stylingType.type) >= 0
            ? "-1.5rem"
            : "-1rem"});`
        : alignByContent === "right"
            ? `transform: translate(${["primary", "secondary"].indexOf(stylingType.type) >= 0
                ? "1.5rem"
                : "1rem"});`
            : ""}
          `
    : isVideo || isIcon
        ? alignByContent === "left"
            ? `transform: translate(-${((itemHeight.medium || itemHeight.xsmall) -
                (itemHeight.medium || itemHeight.xsmall >= buttonHeights.large
                    ? 1.25
                    : 1)) /
                2}rem);`
            : alignByContent === "right"
                ? `transform: translate(${((itemHeight.medium || itemHeight.xsmall) -
                    (itemHeight.medium || itemHeight.xsmall >= buttonHeights.large
                        ? 1.25
                        : 1)) /
                    2}rem);`
                : ""
        : ""};
  }

  @media ${({ theme }) => theme.device.large} {
    ${({ isVideo, itemHeight }) => !isVideo && itemHeight.large ? `height: ${itemHeight.large}rem` : ""};
    span {
      ${({ isVideo, itemHeight }) => !isVideo ? `height: ${itemHeight.large}rem` : ""};
      ${({ itemHeight }) => `min-width: ${itemHeight.large}rem;`}
    }
    ${({ itemHeight, theme }) => {
    if (!itemHeight.large)
        return "";
    if (itemHeight.large >= buttonHeights.large) {
        return `
        font-size: ${theme.fontTokens.font11[0]}; 
        line-height: ${theme.fontTokens.font11[1]}; 
        svg {
          width: 1.25rem;
        }`;
    }
    return `
      font-size: ${theme.fontTokens.font12[0]}; 
      line-height: ${theme.fontTokens.font12[1]};
      svg {
        width: 1rem;
      }
      `;
}}
    ${({ isIcon, stretched, itemHeight, isVideo, stylingType, symbol }) => {
    if (isVideo)
        return "";
    if (isIcon) {
        return itemHeight.large ? `width: ${itemHeight.large}rem;` : "";
    }
    if (stretched.large) {
        return "min-width: 100%;";
    }
    if (stylingType.type && stylingType.type.includes("flat")) {
        if (symbol) {
            return `min-width: 3.75rem;`;
        }
        return `min-width: 2.5rem;`;
    }
    return `min-width: 6.25rem;`;
}}
    ${({ isIcon, hasChildren, symbol, isVideo, itemHeight, stylingType, alignByContent, }) => !isVideo && !isIcon && (!symbol || !hasChildren)
    ? `
        padding: ${getButtonPadding(itemHeight === null || itemHeight === void 0 ? void 0 : itemHeight.large)} ${["primary", "secondary"].indexOf(stylingType.type) >= 0
        ? "1.5rem"
        : "1rem"};
          ${alignByContent === "left"
        ? `transform: translate(${["primary", "secondary"].indexOf(stylingType.type) >= 0
            ? "-1.5rem"
            : "-1rem"});`
        : alignByContent === "right"
            ? `transform: translate(${["primary", "secondary"].indexOf(stylingType.type) >= 0
                ? "1.5rem"
                : "1rem"});`
            : ""}
          `
    : isVideo || isIcon
        ? alignByContent === "left"
            ? `transform: translate(-${((itemHeight.large || itemHeight.xsmall) -
                (itemHeight.large || itemHeight.xsmall >= buttonHeights.large
                    ? 1.25
                    : 1)) /
                2}rem);`
            : alignByContent === "right"
                ? `transform: translate(${((itemHeight.large || itemHeight.xsmall) -
                    (itemHeight.large || itemHeight.xsmall >= buttonHeights.large
                        ? 1.25
                        : 1)) /
                    2}rem);`
                : ""
        : ""};
  }

  @media ${({ theme }) => theme.device.xlarge} {
    ${({ isVideo, itemHeight }) => !isVideo && itemHeight.xlarge ? `height: ${itemHeight.xlarge}rem` : ""};
    span {
      ${({ isVideo, itemHeight }) => !isVideo ? `height: ${itemHeight.xlarge}rem` : ""};
      ${({ itemHeight }) => `width: ${itemHeight.xlarge}rem;`}
    }

    ${({ itemHeight, theme }) => {
    if (!itemHeight.xlarge)
        return "";
    if (itemHeight.xlarge >= buttonHeights.large)
        return `
        font-size: ${theme.fontTokens.font11[0]}; 
        line-height: ${theme.fontTokens.font11[1]};
        svg {
          width: 1.25rem;
        }`;
    return `
      font-size: ${theme.fontTokens.font12[0]};
      ine-height: ${theme.fontTokens.font12[1]};
      svg {
          width: 1rem;
        }`;
}}
    ${({ isIcon, stretched, itemHeight, isVideo, stylingType, symbol }) => {
    if (isVideo)
        return "";
    if (isIcon) {
        return itemHeight.xlarge ? `width: ${itemHeight.xlarge}rem;` : "";
    }
    if (stretched.xlarge) {
        return "min-width: 100%;";
    }
    if (stylingType.type && stylingType.type.includes("flat")) {
        if (symbol) {
            return `min-width: 3.75rem;`;
        }
        return `min-width: 2.5rem;`;
    }
    return `min-width: 6.25rem;`;
}}
  }

  @media ${({ theme }) => theme.device.touch} {
    ${({ isVideo, itemHeight }) => !isVideo && (itemHeight.xsmall === 2.5 || itemHeight.medium === 2.5)
    ? `height: 2.75rem`
    : ""};
    span {
      ${({ isVideo, itemHeight }) => !isVideo && (itemHeight.xsmall === 2.5 || itemHeight.medium === 2.5)
    ? `height: 2.75rem`
    : ``};
      ${({ itemHeight }) => itemHeight.xsmall === 2.5 || itemHeight.medium === 2.5
    ? `min-width: 2.75rem;`
    : ""}
    }

    ${({ isIcon, stretched, itemHeight, isVideo, stylingType, symbol }) => {
    if (isVideo)
        return "";
    if (isIcon) {
        return itemHeight.xsmall === 2.5 || itemHeight.medium === 2.5
            ? `width: 2.75rem;`
            : "";
    }
    if (stretched.medium) {
        return "min-width: 100%;";
    }
    if (stylingType.type && stylingType.type.includes("flat")) {
        if (symbol) {
            return `min-width: 3.75rem;`;
        }
        return `min-width: 2.75rem;`;
    }
    return `min-width: 6.25rem;`;
}}
  }
`;
